// @flow

export const SET_PRODUCT_CONFIGURATIONS = 'SET_PRODUCT_CONFIGURATIONS'
export const SET_AVAILABLE_FILTER_ENTITIES = 'SET_AVAILABLE_FILTER_ENTITIES'
export const SET_SELECTED_CUSTOMER_GROUPS = 'SET_SELECTED_CUSTOMER_GROUPS'
export const SET_SELECTED_PRODUCT_COLLECTIONS = 'SET_SELECTED_PRODUCT_COLLECTIONS'
export const SET_SELECTED_MODALITIES = 'SET_SELECTED_MODALITIES'
export const SET_SELECTED_REGIONS = 'SET_SELECTED_REGIONS'
export const SET_SELECTED_TERMS = 'SET_SELECTED_TERMS'
export const SET_START_DATE = 'SET_START_DATE'
export const DESELECT_FILTER_ENTITIES = 'DESELECT_FILTER_ENTITIES'
export const RESET_SELECTED_FILTERS = 'RESET_SELECTED_FILTERS'

export default {
  SET_PRODUCT_CONFIGURATIONS,
  SET_AVAILABLE_FILTER_ENTITIES,
  SET_SELECTED_CUSTOMER_GROUPS,
  SET_SELECTED_PRODUCT_COLLECTIONS,
  SET_SELECTED_MODALITIES,
  SET_SELECTED_REGIONS,
  SET_SELECTED_TERMS,
  SET_START_DATE,
  DESELECT_FILTER_ENTITIES,
  RESET_SELECTED_FILTERS
}



// WEBPACK FOOTER //
// ./src/store/modules/selection/mutation-types.js